import { MrbBaseRouteStore } from "mrb/core";
import { AppStoreHomeSectionService } from "common/services";

class LoadioStoreHomeSectionListRouteStore extends MrbBaseRouteStore {
    constructor(rootStore) {
        super(rootStore);

        this.service = rootStore.createApplicationService(AppStoreHomeSectionService);
    }

    async getAll() {
        const response = await this.service.getLoadioAll({
            embed: "items,items.loadioAlbum,items.loadioArtist",
        });
        return response.data;
    }

    async update(resources) {
        const response = await this.service.updateLoadio(resources);
        return response.data;
    }

    async getContent(filter) {
        const response = await this.service.getLoadioContent(filter);
        return response.data;
    }
}

export default LoadioStoreHomeSectionListRouteStore;
